import placeholder from '../../images/general/Apsam.png';

const IMAGES_EVENEMENTS = [
  placeholder,
];

export default IMAGES_EVENEMENTS;
